// @generated by protobuf-ts 2.9.4 with parameter generate_dependencies,optimize_code_size
// @generated from protobuf file "backend/v1/bank_link.proto" (package "backend.v1", syntax proto3)
// tslint:disable
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../google/protobuf/timestamp";
import { Date } from "../../core/v1/date";
import { LoanType } from "../../core/v1/debts";
import { AccountType } from "../../core/v1/accounts";
// Bank connections through Flinks Connect (read-only). Onboarding uses them to fill in balances: the
// client opens the Flinks iframe, gets a login id when the user finishes, and asks the backend to read
// that login's accounts. The backend keeps the connection and which family entity each bank account
// fills, reads it again daily, and applies newer balances at the user's next check-in.

/**
 * POST /api/bank-link/session: a Flinks Connect iframe URL with a fresh authorize token.
 *
 * @generated from protobuf message backend.v1.BankLinkSession
 */
export interface BankLinkSession {
    /**
     * @generated from protobuf field: string iframe_url = 1;
     */
    iframeUrl: string;
}
/**
 * POST /api/bank-link/import
 *
 * @generated from protobuf message backend.v1.ImportBankAccountsRequest
 */
export interface ImportBankAccountsRequest {
    /**
     * @generated from protobuf field: string login_id = 1;
     */
    loginId: string; // from the iframe's REDIRECT event
    /**
     * @generated from protobuf field: string owner_uuid = 2;
     */
    ownerUuid: string; // the household member whose accounts these are
}
/**
 * One account at the bank, as one of ours. Balances are positive: what's in it, or what's owed.
 *
 * @generated from protobuf message backend.v1.ImportedAccount
 */
export interface ImportedAccount {
    /**
     * @generated from protobuf field: string external_id = 1;
     */
    externalId: string; // the bank's (Flinks) account id; the same account on a later import
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string; // the bank's title, e.g. "Chequing CAD"
    /**
     * @generated from protobuf oneof: kind
     */
    kind: {
        oneofKind: "accountType";
        /**
         * @generated from protobuf field: core.v1.AccountType account_type = 3;
         */
        accountType: AccountType; // chequing, savings (with savings), registered, trading
    } | {
        oneofKind: "loanType";
        /**
         * @generated from protobuf field: core.v1.LoanType loan_type = 4;
         */
        loanType: LoanType; // credit cards, lines of credit, loans
    } | {
        oneofKind: "mortgage";
        /**
         * @generated from protobuf field: bool mortgage = 5;
         */
        mortgage: boolean;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: bool savings = 6;
     */
    savings: boolean; // account_type CHEQUING only
    /**
     * @generated from protobuf field: double balance = 7;
     */
    balance: number;
    /**
     * @generated from protobuf field: optional double credit_limit = 8;
     */
    creditLimit?: number;
    /**
     * The uuid to give the family entity it fills (the account, card, loan or mortgage). Chosen by the
     * backend and kept for the same bank account, so later balances find it.
     *
     * @generated from protobuf field: string entity_uuid = 9;
     */
    entityUuid: string;
}
/**
 * An account we left out, and why (shown so the user knows to add it by hand).
 *
 * @generated from protobuf message backend.v1.SkippedBankAccount
 */
export interface SkippedBankAccount {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: string reason = 2;
     */
    reason: string;
}
/**
 * @generated from protobuf message backend.v1.ImportBankAccountsResponse
 */
export interface ImportBankAccountsResponse {
    /**
     * @generated from protobuf field: string institution = 1;
     */
    institution: string;
    /**
     * @generated from protobuf field: core.v1.Date as_of = 2;
     */
    asOf?: Date; // the date the balances were read
    /**
     * @generated from protobuf field: repeated backend.v1.ImportedAccount accounts = 3;
     */
    accounts: ImportedAccount[];
    /**
     * @generated from protobuf field: repeated backend.v1.SkippedBankAccount skipped = 4;
     */
    skipped: SkippedBankAccount[];
    /**
     * @generated from protobuf field: string connection_id = 5;
     */
    connectionId: string; // for DELETE /api/bank-link/connections/:id
}
/**
 * GET /api/bank-link/connections
 *
 * @generated from protobuf message backend.v1.BankConnection
 */
export interface BankConnection {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string institution = 2;
     */
    institution: string;
    /**
     * @generated from protobuf field: string owner_uuid = 3;
     */
    ownerUuid: string;
    /**
     * @generated from protobuf field: backend.v1.BankConnection.Status status = 4;
     */
    status: BankConnection_Status;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_refresh_at = 5;
     */
    lastRefreshAt?: Timestamp; // when Flinks last read the bank
    /**
     * The family entities its bank accounts fill: kept current while OK, to verify by hand while not.
     *
     * @generated from protobuf field: repeated string entity_uuids = 6;
     */
    entityUuids: string[];
}
/**
 * @generated from protobuf enum backend.v1.BankConnection.Status
 */
export enum BankConnection_Status {
    /**
     * @generated from protobuf enum value: STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: STATUS_OK = 1;
     */
    OK = 1,
    /**
     * the bank needs the user before it can be read again
     *
     * @generated from protobuf enum value: STATUS_NEEDS_RECONNECT = 2;
     */
    NEEDS_RECONNECT = 2
}
/**
 * A balance read since it was last applied: the next check-in applies it (source FLINKS).
 *
 * @generated from protobuf message backend.v1.PendingBalance
 */
export interface PendingBalance {
    /**
     * @generated from protobuf field: string entity_uuid = 1;
     */
    entityUuid: string;
    /**
     * @generated from protobuf field: double balance = 2;
     */
    balance: number;
    /**
     * @generated from protobuf field: core.v1.Date as_of = 3;
     */
    asOf?: Date;
    /**
     * @generated from protobuf field: string institution = 4;
     */
    institution: string;
}
/**
 * @generated from protobuf message backend.v1.ListBankConnectionsResponse
 */
export interface ListBankConnectionsResponse {
    /**
     * @generated from protobuf field: repeated backend.v1.BankConnection connections = 1;
     */
    connections: BankConnection[];
    /**
     * @generated from protobuf field: repeated backend.v1.PendingBalance pending = 2;
     */
    pending: PendingBalance[]; // only for entities in the stored family, newer than its facts
}
/**
 * POST /api/bank-link/connections/:id/reconnect: a live read of the bank. When the bank needs the user
 * (a security question or a code), `iframe_url` opens Flinks Connect on that request, and the client
 * calls POST /api/bank-link/connections/:id/refresh once Flinks reports success. Otherwise the read is
 * done and `connection` is the connection afterwards.
 *
 * @generated from protobuf message backend.v1.ReconnectBankResponse
 */
export interface ReconnectBankResponse {
    /**
     * @generated from protobuf field: string iframe_url = 1;
     */
    iframeUrl: string;
    /**
     * @generated from protobuf field: backend.v1.BankConnection connection = 2;
     */
    connection?: BankConnection;
}
// @generated message type with reflection information, may provide speed optimized methods
class BankLinkSession$Type extends MessageType<BankLinkSession> {
    constructor() {
        super("backend.v1.BankLinkSession", [
            { no: 1, name: "iframe_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.BankLinkSession
 */
export const BankLinkSession = new BankLinkSession$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ImportBankAccountsRequest$Type extends MessageType<ImportBankAccountsRequest> {
    constructor() {
        super("backend.v1.ImportBankAccountsRequest", [
            { no: 1, name: "login_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "owner_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.ImportBankAccountsRequest
 */
export const ImportBankAccountsRequest = new ImportBankAccountsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ImportedAccount$Type extends MessageType<ImportedAccount> {
    constructor() {
        super("backend.v1.ImportedAccount", [
            { no: 1, name: "external_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "account_type", kind: "enum", oneof: "kind", T: () => ["core.v1.AccountType", AccountType, "ACCOUNT_TYPE_"] },
            { no: 4, name: "loan_type", kind: "enum", oneof: "kind", T: () => ["core.v1.LoanType", LoanType, "LOAN_TYPE_"] },
            { no: 5, name: "mortgage", kind: "scalar", oneof: "kind", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "savings", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "balance", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "credit_limit", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "entity_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.ImportedAccount
 */
export const ImportedAccount = new ImportedAccount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SkippedBankAccount$Type extends MessageType<SkippedBankAccount> {
    constructor() {
        super("backend.v1.SkippedBankAccount", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.SkippedBankAccount
 */
export const SkippedBankAccount = new SkippedBankAccount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ImportBankAccountsResponse$Type extends MessageType<ImportBankAccountsResponse> {
    constructor() {
        super("backend.v1.ImportBankAccountsResponse", [
            { no: 1, name: "institution", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "as_of", kind: "message", T: () => Date },
            { no: 3, name: "accounts", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ImportedAccount },
            { no: 4, name: "skipped", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => SkippedBankAccount },
            { no: 5, name: "connection_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.ImportBankAccountsResponse
 */
export const ImportBankAccountsResponse = new ImportBankAccountsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BankConnection$Type extends MessageType<BankConnection> {
    constructor() {
        super("backend.v1.BankConnection", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "institution", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "owner_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "status", kind: "enum", T: () => ["backend.v1.BankConnection.Status", BankConnection_Status, "STATUS_"] },
            { no: 5, name: "last_refresh_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "entity_uuids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.BankConnection
 */
export const BankConnection = new BankConnection$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PendingBalance$Type extends MessageType<PendingBalance> {
    constructor() {
        super("backend.v1.PendingBalance", [
            { no: 1, name: "entity_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "balance", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "as_of", kind: "message", T: () => Date },
            { no: 4, name: "institution", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.PendingBalance
 */
export const PendingBalance = new PendingBalance$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListBankConnectionsResponse$Type extends MessageType<ListBankConnectionsResponse> {
    constructor() {
        super("backend.v1.ListBankConnectionsResponse", [
            { no: 1, name: "connections", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => BankConnection },
            { no: 2, name: "pending", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => PendingBalance }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.ListBankConnectionsResponse
 */
export const ListBankConnectionsResponse = new ListBankConnectionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReconnectBankResponse$Type extends MessageType<ReconnectBankResponse> {
    constructor() {
        super("backend.v1.ReconnectBankResponse", [
            { no: 1, name: "iframe_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "connection", kind: "message", T: () => BankConnection }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.ReconnectBankResponse
 */
export const ReconnectBankResponse = new ReconnectBankResponse$Type();
